module.exports = __webpack_public_path__ + "static/img/gen_root4.65bce8f4.jpg";